__turbopack_context__.v({
  "className": "myfont_5f69936f-module__CL8iJG__className",
});
